/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

export const PERSIST_DATE_FMT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FMT = 'MM/DD/YYYY';

export const PERSIST_DATETIME_FMT = 'YYYY-MM-DDTHH:mm:ss';
export const DISPLAY_DATETIME_FMT = 'MM/DD/YYYY hh:mm A z';

export const DISPLAY_TIME_FMT = 'hh:mm A z';

export const EMPTY_DISPLAY = '--';
